export class PlatformAccountBase {
  public username: string;
  public password: string;
  public platformAccountId?: string;
  public platformId: number;
  public clientApiId?: string;
  public clientApiSecret?: string;
}
